import { render, staticRenderFns } from "./CarrouselCourseViewed.vue?vue&type=template&id=eb4636e4&scoped=true"
import script from "./CarrouselCourseViewed.vue?vue&type=script&lang=js"
export * from "./CarrouselCourseViewed.vue?vue&type=script&lang=js"
import style0 from "./CarrouselCourseViewed.vue?vue&type=style&index=0&id=eb4636e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4636e4",
  null
  
)

export default component.exports